import { useRef } from 'react';
import { AssistantBubble } from '@/components/virtual-assistant/assistant-bubble';
import { useAutoScrollBottom } from '@/components/virtual-assistant/use-auto-scroll-bottom';
import { UserBubble } from '@/components/virtual-assistant/user-bubble';
import { ProductModel } from '@/models';
import styles from './virtual-assistant-timeline.module.scss';

export type AssistantMessage = {
	id: string;
	role: 'user' | 'assistant';
	text: string;
	suggestions?: string[];
	products?: ProductModel[];
	status: 'pending' | 'done';
};

type Props = {
	messages: AssistantMessage[];
	isLoading: boolean;
	submitChanges: (changes: string) => void;
};

export const VirtualAssistantTimeline = ({ messages, submitChanges, isLoading = false }: Props) => {
	const scrollRef = useRef<HTMLDivElement>(null);

	useAutoScrollBottom(scrollRef, [messages]);

	return (
		<div className={styles.timeline} ref={scrollRef}>
			{messages.map((msg) =>
				msg.role === 'user' ? (
					<UserBubble key={msg.id} text={msg.text} />
				) : (
					<AssistantBubble key={msg.id} message={msg} onSuggestionClick={submitChanges} />
				),
			)}
		</div>
	);
};
